import AppConfigs from "../Config/AppConfig";
import React from 'react'
import moment from "moment";
import { add } from "../api/Apis";
import { message } from "antd";
import NumberFormat from "react-number-format";

export function formatPhoneNumber(phoneNumberString) {
  var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
  var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return "(" + match[1] + ") " + match[2] + "-" + match[3];
  }
  return phoneNumberString;
}
//phonenumber with more than ten digits
export function formatPhoneNumber1(phoneNumberString) {
  var cleaned = ("" + phoneNumberString).replace(/\D/g, "").slice(-10);
  var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return "(" + match[1] + ") " + match[2] + "-" + match[3];
  }
  return null;
}

export function showTotal(total, range) {
  return `${range[0]}-${range[1]} of ${total} items`;
}

export function ordersSort(pagination, filters, sorter, loadsData) {
  let loadList = [];
  if (sorter["order"] === "descend") {
    if (sorter["columnKey"] === "orderStatus") {
      loadList = loadsData.sort((a, b) =>
        AppConfigs["DISPLAY_LEAD_STATUS"]["admin"][a["orderStatus"]] <
        AppConfigs["DISPLAY_LEAD_STATUS"]["admin"][b["orderStatus"]]
          ? 1
          : -1
      );
    } else if (sorter["columnKey"] === "poNumber") {
      loadList = loadsData.sort((a, b) =>
        a["poNumber"] < b["poNumber"] ? 1 : -1
      );
    } else if (
      sorter["columnKey"] === "orderId" ||
      sorter["columnKey"] === "subOrderId"
    ) {
      loadList = loadsData.sort((a, b) =>
        parseInt(a["orderId"]) < parseInt(b["orderId"]) ? 1 : -1
      );
    } else if (sorter["columnKey"] === "customerName") {
      loadList = loadsData.sort((a, b) =>
        a["customerName"].toLowerCase() < b["customerName"].toLowerCase()
          ? 1
          : -1
      );
    } else if (sorter["columnKey"] === "productName") {
      loadList = loadsData.sort((a, b) =>
        a["productName"].toLowerCase() < b["productName"].toLowerCase() ? 1 : -1
      );
    } else if (sorter["columnKey"] === "assignCarrier") {
      loadList = loadsData
        .filter((l) => l.assignCarrier === true)
        .sort((a, b) =>
          "carrierDetails" in a !== false && "carrierDetails" in b !== false
            ? a["carrierDetails"]["carrierName"].toLowerCase() <
              b["carrierDetails"]["carrierName"].toLowerCase()
              ? 1
              : -1
            : -1
        );
      loadList = loadList.concat(
        loadsData.filter((l) => l.assignCarrier === false)
      );
    } else if (sorter["columnKey"] === "createdAt") {
      loadList = loadsData.sort((a, b) =>
        parseInt(a["createdAt"]) < parseInt(b["createdAt"]) ? 1 : -1
      );
    } else if (sorter["columnKey"] === "deliveryReqDate") {
      loadList = loadsData.sort((a, b) =>
        moment(a["deliveryReqDate"], "MM/DD/YYYY") <
        moment(b["deliveryReqDate"], "MM/DD/YYYY")
          ? 1
          : -1
      );
    } else if (sorter["columnKey"] === "pickupDate") {
      loadList = loadsData
        .filter((p) => p.pickupDate)
        .sort((a, b) =>
          moment(a["pickupDate"], "MM/DD/YYYY") <
          moment(b["pickupDate"], "MM/DD/YYYY")
            ? 1
            : -1
        );
      loadList = loadList.concat(loadsData.filter((p) => !p.pickupDate));
    } else if (sorter["columnKey"] === "deliveryTruck") {
      loadList = loadsData.sort((a, b) =>
        a["cartItems"][0]["deliveryTruck"].toLowerCase() <
        b["cartItems"][0]["deliveryTruck"].toLowerCase()
          ? 1
          : -1
      );
    } else if (sorter["columnKey"] === "location") {
      loadList = loadsData.sort((a, b) =>
        a["cartItems"][0]["locationName"]?.toLowerCase() <
        b["cartItems"][0]["locationName"]?.toLowerCase()
          ? 1
          : -1
      );
    } else if (sorter["columnKey"] === "callForRate") {
      loadList = loadsData
        .filter((p) => p.callForRate === false)
        .sort((a, b) =>
          parseInt(a["rateValue"]) < parseInt(b["rateValue"]) ? 1 : -1
        );
      loadList = loadList.concat(
        loadsData.filter((p) => p.callForRate === true)
      );
    } else if (sorter["columnKey"] === "distanceMiles") {
      loadList = loadsData.sort((a, b) =>
        parseInt(a["distanceMiles"]) < parseInt(b["distanceMiles"]) ? 1 : -1
      );
    }
  } else if (sorter["order"] === "ascend") {
    if (sorter["columnKey"] === "orderStatus") {
      loadList = loadsData.sort((a, b) =>
        AppConfigs["DISPLAY_LEAD_STATUS"]["admin"][a["orderStatus"]] >
        AppConfigs["DISPLAY_LEAD_STATUS"]["admin"][b["orderStatus"]]
          ? 1
          : -1
      );
    } else if (sorter["columnKey"] === "poNumber") {
      loadList = loadsData.sort((a, b) =>
        a["poNumber"] > b["poNumber"] ? 1 : -1
      );
    } else if (
      sorter["columnKey"] === "orderId" ||
      sorter["columnKey"] === "subOrderId"
    ) {
      loadList = loadsData.sort((a, b) =>
        parseInt(a["orderId"]) > parseInt(b["orderId"]) ? 1 : -1
      );
    } else if (sorter["columnKey"] === "productName") {
      loadList = loadsData.sort((a, b) =>
        a["productName"].toLowerCase() > b["productName"].toLowerCase() ? 1 : -1
      );
    } else if (sorter["columnKey"] === "customerName") {
      loadList = loadsData.sort((a, b) =>
        a["customerName"].toLowerCase() > b["customerName"].toLowerCase()
          ? 1
          : -1
      );
    } else if (sorter["columnKey"] === "assignCarrier") {
      loadList = loadsData
        .filter((l) => l.assignCarrier === true)
        .sort((a, b) =>
          "carrierDetails" in a !== false && "carrierDetails" in b !== false
            ? a["carrierDetails"]["carrierName"].toLowerCase() >
              b["carrierDetails"]["carrierName"].toLowerCase()
              ? 1
              : -1
            : -1
        );
      loadList = loadList.concat(
        loadsData.filter((l) => l.assignCarrier === false)
      );
    } else if (sorter["columnKey"] === "createdAt") {
      loadList = loadsData.sort((a, b) =>
        parseInt(a["createdAt"]) > parseInt(b["createdAt"]) ? 1 : -1
      );
    } else if (sorter["columnKey"] === "deliveryReqDate") {
      loadList = loadsData.sort((a, b) =>
        moment(a["deliveryReqDate"], "MM/DD/YYYY").isAfter(
          moment(b["deliveryReqDate"], "MM/DD/YYYY")
        )
          ? 1
          : -1
      );
    } else if (sorter["columnKey"] === "pickupDate") {
      loadList = loadsData
        .filter((p) => p.pickupDate)
        .sort((a, b) =>
          moment(a["pickupDate"], "MM/DD/YYYY").isAfter(
            moment(b["pickupDate"], "MM/DD/YYYY")
          )
            ? 1
            : -1
        );
      loadList = loadList.concat(loadsData.filter((p) => !p.pickupDate));
    } else if (sorter["columnKey"] === "deliveryTruck") {
      loadList = loadsData.sort((a, b) =>
        a["cartItems"][0]["deliveryTruck"].toLowerCase() >
        b["cartItems"][0]["deliveryTruck"].toLowerCase()
          ? 1
          : -1
      );
    } else if (sorter["columnKey"] === "location") {
      loadList = loadsData.sort((a, b) =>
        a["cartItems"][0]["locationName"]?.toLowerCase() >
        b["cartItems"][0]["locationName"]?.toLowerCase()
          ? 1
          : -1
      );
    } else if (sorter["columnKey"] === "callForRate") {
      loadList = loadsData.filter((p) => p.callForRate === true);
      loadList = loadList.concat(
        loadsData
          .filter((p) => p.callForRate === false)
          .sort((a, b) =>
            parseInt(a["rateValue"]) > parseInt(b["rateValue"]) ? 1 : -1
          )
      );
    } else if (sorter["columnKey"] === "distanceMiles") {
      loadList = loadsData.sort((a, b) =>
        parseInt(a["distanceMiles"]) > parseInt(b["distanceMiles"]) ? 1 : -1
      );
    }
  } else {
    loadList = loadsData;
  }
  return loadList;
}


export function createRequestLoad(leadData) {
  let orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
  let data = {
    entityData: {
      leadId: leadData["id"],
      carrierId: orgDetails["id"],
      carrierName: orgDetails["companyName"],
      rateValue: leadData["rateValue"],
      callForRate: leadData["callForRate"],
      rateAmt: leadData["rateAmt"],
      rateOption: leadData["rateOption"],
      pickupDate: null,
      pickupStartTime: null,
      pickupEndTime: null,
      driverDetails: {},
      truckDetails: {},
      carrierEmail: orgDetails["email"],
      orderStatus: AppConfigs["IN_PROGRESS"],
    },
  };
  add(AppConfigs["assignLead"], data).then((result) => {
    if (result.success) {
      message.success("Load assigned successfully!");
      window.location.reload()
      return;
    } else {
      console.log(result.errors);
      this.props.history.push("/carrier_app/allOrders");
    }
  });
}
export default function priceFormate(value,prif=true) {
  return (
    <>
      <NumberFormat
        value={parseFloat(value).toFixed(2)}
        displayType={"text"}
        thousandSeparator={true}
        prefix={prif ? "$" :""}
      />
    </>
  )
}